<template>
  <div
    class="field"
    :class="{ 'select-search-disabled': disabled }"
  >
    <label
      class="label"
      :for="id"
    >
      {{ label }}
    </label>
    <div
      class="control"
      :class="{ 'is-loading': isLoading }"
    >
      <VueSearchSelect
        :id="id"
        :options="options"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        :taggable="taggable"
        :select-on-tab="tab"
        @input="onChange"
        @search="onSearch"
        @search:focus="$emit('focus', $emit)"
        @search:blur="$emit('blur', $emit)"
      >
        <span slot="no-options">
          {{ emptyMessage }}
        </span>
        <slot name="spinner">
          {{ loadingMessage }}
        </slot>
      </VueSearchSelect>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'AppSelectSearch',
  components: {
    VueSearchSelect: () => import(/* webpackChunkName: "vue-search-select" */ 'vue-select'),
  },
  props: {
    tab: {
      type: Boolean,
      default: true,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: [String, Number],
      default: '',
    },
    pattern: {
      type: String,
      default: '',
    },
    searchLabel: {
      type: String,
      default: '',
    },
    leftIcon: {
      type: String,
      default: '',
    },
    rightIcon: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Object],
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: () => [],
    },
    emptyMessage: {
      type: String,
      default: 'Sin ocurrencias',
    },
    loadingMessage: {
      type: String,
      default: 'Cargando...',
    },
    onSearch: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    onChange(obj) {
      const maxLength = 1000;
      const label = obj ? obj.label : '';
      const objValue = typeof (obj) === 'object' ? get(obj, 'value', '') : obj;
      const value = objValue || label;

      const event = {
        target: {
          name: this.name,
          value: this.name === 'description' ? value.substring(0, maxLength) : value,
        },
      };

      this.$emit('change', event);
    },
  },
};
</script>

<style>
.field.select-search-disabled .v-select.disabled .dropdown-toggle {
  border: none;
}

.field.select-search-disabled .v-select.disabled .dropdown-toggle input {
  display: none;
}

.field.select-search-disabled .dropdown.v-select .vs__actions .clear {
  display: none;
}

.field.select-search-disabled .dropdown.v-select .vs__actions .open-indicator:before {
  display: none;
}

.dropdown.v-select {
  height: 2.25em;
}

.dropdown.v-select .vs__actions .clear {
  color: #ff3860
}

.dropdown.v-select .vs__actions .open-indicator:before {
  border-color: #3273dc;
}

.dropdown.v-select .vs__selected-options {
  width: calc(100% - 48px);
}

.dropdown.v-select.single .selected-tag {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.control .dropdown,
.control .dropdown .dropdown-toggle {
  width: 100%;
}
</style>
